import React from "react";


const Rst = () => {

    return (
        <div className="component-box">
            <div className="inline-box">
                <img src="img/box-blue.png" alt="cpu" className="icon led-icon" />
                <span>周辺機器</span>
            </div>
            <div className="led-box row">
                <div className="col-md-7">
                    <div className="title-box"><span>2. RSTボタン</span></div>
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>RSTボタン</th>
                                <th>ステータス</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><img src="img/grey-circle.png" />RST button check</td>
                                <td></td>
                            </tr>

                        </tbody>
                    </table>

                    <div className="info-message rst-message">
                        <img src="img/info.png" alt="info" />
                        <span>RST ボタンを押してステータスを確認します。ボタンが機能している場合、ステータスは「ok」になります。</span>
                    </div>

                </div>
                <div className="col-md-5 smart-ai">
                    <img src="img/poke.png" className="poke rst-poke" />
                    <img src="img/smartai.png" className="smartai" />
                </div>
                {/* <div className="col-md-12">
                    <div className="box-wrapper">
                        <span>RSTボタンチェックを終了</span>
                        <button>OK</button>
                    </div>
                </div> */}

                <div className="col-md-12">
                    <div className="box-wrapper failed-wrapper">
                        <span>RSTボタンの接続を確認できません。</span>
                        <div className="two-button-box">
                            <button className="retry">リトライ</button>
                            <button className="skip">スキップ</button>
                        </div>
                    </div>
                </div>

            </div>


        </div>

    );
};

export default Rst;